import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";

import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Article from "@/pages/Article";
import Archive from "@/pages/Archive";
import Search from "@/pages/Search";
import { StaticPage } from "@/pages/StaticPage";

import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Articles from "@/pages/admin/Articles";
import Editor from "@/pages/admin/Editor";
import Media from "@/pages/admin/Media";
import Users from "@/pages/admin/Users";
import RssImport from "@/pages/admin/RssImport";
import NewsletterSubs from "@/pages/admin/NewsletterSubs";
import PreviewArticle from "@/pages/admin/PreviewArticle";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/rubrik/:slug" element={<Category />} />
          <Route path="/artikel/:slug" element={<Article />} />
          <Route path="/archiv" element={<Archive />} />
          <Route path="/suche" element={<Search />} />
          <Route path="/impressum" element={<StaticPage page="impressum" />} />
          <Route path="/kontakt" element={<StaticPage page="kontakt" />} />
          <Route path="/datenschutz" element={<StaticPage page="datenschutz" />} />

          {/* Admin */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin/artikel" element={<ProtectedRoute><Articles /></ProtectedRoute>} />
          <Route path="/admin/artikel/neu" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
          <Route path="/admin/artikel/:id/vorschau" element={<ProtectedRoute><PreviewArticle /></ProtectedRoute>} />
          <Route path="/admin/artikel/:id" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
          <Route path="/admin/mediathek" element={<ProtectedRoute><Media /></ProtectedRoute>} />
          <Route path="/admin/rss" element={<ProtectedRoute adminOnly><RssImport /></ProtectedRoute>} />
          <Route path="/admin/newsletter" element={<ProtectedRoute adminOnly><NewsletterSubs /></ProtectedRoute>} />
          <Route path="/admin/benutzer" element={<ProtectedRoute adminOnly><Users /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
